export const SPOTIFY_CONFIG = {
  CLIENT_ID: process.env.REACT_APP_SPOTIFY_CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_SPOTIFY_CLIENT_SECRET,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URL,
  SCOPES: [
    'user-read-private',
    'user-read-email',
    'user-read-currently-playing',
    'user-read-playback-state'
  ]
};

const requiredSpotifyVars = [
  'REACT_APP_SPOTIFY_CLIENT_ID',
  'REACT_APP_SPOTIFY_CLIENT_SECRET',
  'REACT_APP_REDIRECT_URL'
];

requiredSpotifyVars.forEach(varName => {
  if (!process.env[varName]) {
    console.error(`Missing ${varName} in environment variables`);
    console.log('Available env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
    throw new Error(`Missing required environment variable: ${varName}`);
  }
});